import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import close from "../../../assets/Icons/close.png";
import checkedImg from "../../../assets/Icons/photo-taken.png";
import dOneCheckedImg from "../../../assets/Icons/d-one-photo-taken.jpg"
import error from "../../../assets/svg/failed.svg";
import { useNavigate, useParams } from "react-router-dom";
import { clearImages } from "../../../Store/fullScan";
import { submitScan, deleteReshootImagesS3, updateInsuranceReshootDetails } from "../../../Services/APIs/scan";
import SuccessScreen from "./submitSuccess";
import { encrypt } from "../../../Utils/hmac"

import { generateSteps } from "./steps";
import {
    buttonStyle,
    company_style_details,
    fontStyle,
    fontWeight,
    companyBucket,
} from "../../../Utils/tpscanStyle";
import AlertPopup from "../../StarInsurance/Scan";
import { clearData } from '../../../Store/patientKyc';
// import { postLogDetails } from '../../../Services/APIs/appDetails';
import { createPatientDetails } from '../../../Services/APIs/patient';

const ToothSelector = (props) => {
    const [cameraSide, setCameraSide] = useState(localStorage.getItem("cameraSide") || "front");
    const steps = generateSteps(cameraSide);
    const { setImageSide, setToothPicker } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { images, fullScanS3Folder } = useSelector((state) => state.fullScan);
    const { aadhaarFront, aadhaarBack, panCard } = useSelector((state) => state.reshootFiles);
    const { selectedOptions, reason } = useSelector((state) => state.questionnaire);
    const [isLoading, setLoading] = useState(false);
    const [isSubmitted, setSubmitted] = useState(false);
    const [isError, setError] = useState(false);
    const [doneAlert, setAlert] = useState(false)
    const patientKyc = useSelector((state) => state.patientKyc.patientKyc);
    const handleImageSide = (index) => {
        setImageSide(index);
        setToothPicker(false);
    };
   const uid = JSON.parse(localStorage.getItem("usertpi") || "{}").usertpi
    // const submit = async () => {
    //     setLoading(true);
    //     const isStarInsuranceFlow = localStorage.getItem("scanType")
    //     const starInsuranceUser = isStarInsuranceFlow ? JSON.parse(localStorage.getItem("tl-star-user") || "{}") : {};
    //     const face_url = images.find((eachObj) => eachObj.title === "Face")?.file;

    //     const starInsuranceData = {
    //         face: face_url?.split("/").pop(),
    //         name: starInsuranceUser.name,
    //         phone_number: starInsuranceUser.phone_number,
    //     }
    //     const tooth = {
    //         front_teeth: "Front teeth",
    //         upper_jaw: "Upper jaw",
    //         lower_jaw: "Lower jaw",
    //         left_side: "Left side",
    //         right_side: "Right side",
    //     };
    //     for (const key in tooth) {
    //         images.forEach((eachObj) => {
    //             if (tooth[key] === eachObj.title) {
    //                 starInsuranceData[key] = eachObj.file;
    //             }
    //         });
    //     }
    //     const info = {
    //         uid: JSON.parse(localStorage.getItem('usertpi') || "{}").usertpi,
    //         folderName: JSON.parse(localStorage.getItem('usertpi') || "{}").usertpi,
    //         company: JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket,
    //         ...starInsuranceData
    //     }
    //     console.log(info, "iiii")

    //     await deleteReshootImagesS3(info).then(async (resData) => {

    //         await updateInsuranceReshootDetails(info).then((res) => {
    //             navigate(`/${localStorage.getItem("company")}/${localStorage.getItem("cameraSide")}/thanks`);
    //         }).catch(err => {
    //             console.log(err)
    //             setLoading(false);
    //             setError(true);
    //         })

    //     }).catch((err) => {
    //         setLoading(false);
    //         setError(true);
    //     })

    // };

    const submit = async () => {
        setLoading(true);

        try {
            const isStarInsuranceFlow = localStorage.getItem("scanType");
            const starInsuranceUser = isStarInsuranceFlow
                ? JSON.parse(localStorage.getItem("tl-star-user") || "{}")
                : {};

            const face_url = images.find((eachObj) => eachObj.title === "Face")?.file;

            const starInsuranceData = {
                face: face_url?.split("/").pop(), // only file name
                name: starInsuranceUser.name || "",
                phone_number: starInsuranceUser.phone_number || "",
            };

            const tooth = {
                front_teeth: "Front teeth",
                upper_jaw: "Upper jaw",
                lower_jaw: "Lower jaw",
                left_side: "Left side",
                right_side: "Right side",
            };

            for (const key in tooth) {
                const matched = images.find((eachObj) => eachObj.title === tooth[key]);
                if (matched?.file) {
                    starInsuranceData[key] = matched.file.split("/").pop(); // only file name
                }
            }

            const info = {
                uid,
                folderName: JSON.parse(localStorage.getItem("usertpi") || "{}").usertpi,
                company: JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket,
                ...starInsuranceData,
            };

            // Now build FormData with aadhaar/pan as file and rest in _n
            const formData = new FormData();
            if (aadhaarFront) formData.append("aadhaarFront", aadhaarFront);
            if (aadhaarBack) formData.append("aadhaarBack", aadhaarBack);
            if (panCard) formData.append("panCard", panCard);

            const _n = encrypt(info);
            formData.append("_n", _n);

            await deleteReshootImagesS3(formData).then(async () => {
                await updateInsuranceReshootDetails(formData)
                    .then(() => {
                        navigate(`/review/${uid}/${localStorage.getItem("company")}/${localStorage.getItem("cameraSide")}/review-thanks`);
                    })
                    .catch((err) => {
                        console.error("Update failed", err);
                        setLoading(false);
                        setError(true);
                    });
            }).catch((err) => {
                console.error("Delete failed", err);
                setLoading(false);
                setError(true);
            });

        } catch (err) {
            console.error("Unexpected error", err);
            setLoading(false);
            setError(true);
        }
    };




    const ErrorUI = () => {
        return (
            <div className="h-full absolute top-0 z-10 w-full flex justify-center items-center bg-black/[0.3] backdrop-blur-sm">
                <div className="bg-white w-3/4 flex flex-col items-center p-5 rounded-md shadow-sm">
                    <div className="text-end w-full">
                        {
                            companyBucket === "done" ?
                                <div className="flex justify-end">
                                    <a
                                        href="https://app.dentistry.one/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: "none", color: "inherit" }}>
                                        <img src={close} alt="close_img" width="26px" />
                                    </a>
                                </div> :
                                <button
                                    type="button"
                                    onClick={() => { setError(false) }}>
                                    <img src={close} className="w-6 h-6" alt="close" />
                                </button>
                        }
                    </div>
                    <img src={error} alt="error" className=" w-40 h-40" />
                    <p className="text-center my-5 font-medium">
                        Sorry!! AI is experiencing some difficulty. Please retry in a moment.
                    </p>
                    {companyBucket !== "done" && <div className=" w-full ">
                        <button
                            type="button"
                            className="bg-black text-white w-full h-11 font-semibold text-base shadow-2xl"
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            Back to home page
                        </button>
                    </div>}
                </div>
            </div>
        );
    };

    const Button = (props) => {
        const { i, name, title } = props;
        const checked = images.find((eachObj) => eachObj.title === title);

        return (
            <>
                {checked ? (
                    <img src={(companyBucket === "done" || companyBucket === "hascompanies") ? dOneCheckedImg : checkedImg} alt="checked" className="w-20 h-20 mx-2 rounded-full" />
                ) : (
                    <button
                        className="w-20 h-20 text-xl text-center bg-white rounded-full shadow mx-2"
                        // onClick={() => {
                        //     handleImageSide(i);
                        // }}
                        style={(companyBucket === "done" || companyBucket === "hascompanies") ? { fontSize: "16px" } : {}}
                    >
                        {name}
                    </button>
                )}
            </>
        );
    };


    const isActive = (title) => steps.some(s => s.title === title);
    const getIndex = (title) => steps.findIndex(s => s.title === title);

    const doNavigate = () => {
        (companyBucket === "done" || companyBucket === "hascompanies") ? setAlert(true) : window.history.back()
    };

    return (
        <>
            {isSubmitted ? (
                <SuccessScreen isFullScan={true} />
            ) : (
                <div className={(companyBucket == "done" || companyBucket === "hascompanies") ? "bg-custom-gradient h-full flex flex-col" : "h-full flex flex-col bg-zinc-100"}>
                    <div className={localStorage.getItem("cameraSide") ? "text-end py-4 px-3" : "flex items-center py-4 px-3"}>
                        {!localStorage.getItem("cameraSide") && (
                            <p
                                className="text-sm flex-1"
                                style={
                                    (companyBucket === "done" || companyBucket === "hascompanies")
                                        ? { ...fontStyle, fontSize: "14px" }
                                        : { ...fontWeight, ...fontStyle }
                                }
                            >
                                Tap to capture and preview your photo
                            </p>
                        )}
                        <button
                            className={localStorage.getItem("cameraSide") !== "back" ? "ml-auto" : ""}
                            onClick={() => doNavigate()}
                        >
                            <img src={close} className="w-7 h-7" alt="close" />
                        </button>
                    </div>

                    {/* <div
                        className="flex-grow flex flex-col items-center justify-center font-medium"
                        style={
                            (companyBucket == "done" || companyBucket === "hascompanies")
                                ? { ...fontStyle }
                                : { ...fontWeight, ...fontStyle }
                        }
                    >
                        {steps.find(s => s.title === "Upper jaw") && (
                            <Button i={steps.findIndex(s => s.title === "Upper jaw")} name={"Upper"} title={"Upper jaw"} />
                        )}

                        <div
                            className="flex justify-center my-4"
                            style={
                                (companyBucket === "done" || companyBucket === "hascompanies")
                                    ? { ...fontStyle }
                                    : { ...fontWeight, ...fontStyle }
                            }
                        >
                            {steps.find(s => s.title === "Left side") && (
                                <Button i={steps.findIndex(s => s.title === "Left side")} name={"Left"} title={"Left side"} />
                            )}
                            {steps.find(s => s.title === "Front teeth") && (
                                <Button i={steps.findIndex(s => s.title === "Front teeth")} name={"Front"} title={"Front teeth"} />
                            )}
                            {steps.find(s => s.title === "Right side") && (
                                <Button i={steps.findIndex(s => s.title === "Right side")} name={"Right"} title={"Right side"} />
                            )}
                        </div>

                        {steps.find(s => s.title === "Lower jaw") && (
                            <Button i={steps.findIndex(s => s.title === "Lower jaw")} name={"Lower"} title={"Lower jaw"} />
                        )}

                    </div> */}

                    <div
                        className="flex-grow flex flex-col items-center justify-center font-medium"
                        style={
                            (companyBucket === "done" || companyBucket === "hascompanies")
                                ? { ...fontStyle }
                                : { ...fontWeight, ...fontStyle }
                        }
                    >
                        {/* Upper jaw */}
                        <Button
                            i={getIndex("Upper jaw")}
                            name="Upper"
                            title="Upper jaw"
                            active={isActive("Upper jaw")}
                        />

                        {/* Middle row: Left, Front, Right */}
                        <div
                            className="flex justify-center my-4"
                            style={
                                (companyBucket === "done" || companyBucket === "hascompanies")
                                    ? { ...fontStyle }
                                    : { ...fontWeight, ...fontStyle }
                            }
                        >
                            {["Left side", "Front teeth", "Right side"].map((title) => {
                                const name = title.includes("Left") ? "Left" :
                                    title.includes("Front") ? "Front" : "Right";
                                return (
                                    <Button
                                        key={title}
                                        i={getIndex(title)}
                                        name={name}
                                        title={title}
                                        active={isActive(title)}
                                    />
                                );
                            })}
                        </div>

                        {/* Lower jaw */}
                        <Button
                            i={getIndex("Lower jaw")}
                            name="Lower"
                            title="Lower jaw"
                            active={isActive("Lower jaw")}
                        />
                    </div>


                    <div className="flex justify-center items-center mb-3">
                        {/* //star Insurance flow change this as per total  images in local storage */}
                        {images.length >= steps.length && (
                            <button
                                style={
                                    (companyBucket == "done" || companyBucket === "hascompanies")
                                        ? {
                                            ...buttonStyle,
                                            ...fontStyle,
                                            ...fontWeight,
                                            borderRadius: "30px",
                                        }
                                        : { ...buttonStyle, ...fontStyle, ...fontWeight }
                                }
                                type="button"
                                className="w-40 h-11 bg-black text-white font-semibold m-2 rounded"
                                onClick={submit}
                                disabled={isLoading}
                            >
                                {isLoading ? "Processing..." : "Submit Scan"}
                            </button>
                        )}
                    </div>
                    {isError && <ErrorUI />}
                    {doneAlert && <AlertPopup setPopup={setAlert} />}
                </div>
            )}
        </>
    );
};

export default ToothSelector;
